import {withFormsy} from 'formsy-react';
import React from 'react';
import {DatePicker} from "antd";
// import DatePicker from '../../../js/plugins/date-picker/entry';

class DateInput extends React.Component
{
    constructor(props)
    {
        super(props);
    }

    async changeValue(date) {
        await this.props.setValue(date);

        if (this.props.onDateSelected) {
            this.props.onDateSelected(date)
        }
    }

    render()
    {
        let props = this.props;
        let errorMessage = props.getErrorMessage();
        if (!props.showError() && !props.isFormSubmitted()) {
            errorMessage = null;
        }

        let className = props.showRequired() ? 'required ' : '';

        className += !props.isValid() && props.isFormSubmitted() ? ' text-danger ' : '';
        className += !props.isValid() && props.isFormSubmitted() ? ' is-invalid ' : '';

        let {minDateField} = {...props};

        let minDate, maxDate;
        if (this.props.maxDate) {
            maxDate = TB.moment(this.props.maxDate);
        }
        if(this.props.minDate || minDateField) {
            minDate = TB.moment(this.props.minDate || minDateField)
        }

        // if (minDateField) {
        //     try {
        //         minDateField = TB.moment(String(minDateField.getValue())).clone().endOf('week').add(1, 'day').toDate();
        //     }catch (e) {
        //         console.warn('mindatefield error', minDateField)
        //         minDateField = null;
        //     }
        // }

        let defaultPickerValue = TB.moment();
        if(this.props.getValue()) {
            defaultPickerValue = TB.moment(this.props.getValue());
        }else if(minDate) {
            defaultPickerValue = TB.moment(minDate).clone().add(1, 'day');
        }

        return (
            <div className={"transition-all ease-in flex flex-col form-group " + className + ' ' + this.props.className}>
                {props.label && (
                    <label className="col-form-label">
                        {props.label}
                        {props.required && <span className="required-symbol"> *</span>}
                    </label>
                )}
                <DatePicker
                    key={this.props.name + defaultPickerValue?.format?.("MMM Do, YYYY")}
                    value={this.props.getValue() ? TB.moment(this.props.getValue()) : undefined}
                    onChange={(date, string) => {
                        return this.props.setValue(date?.toISOString())
                    }}
                    size={this.props.size}
                    required={this.props.required}
                    status={errorMessage ? 'error': undefined}
                    defaultPickerValue={defaultPickerValue}
                    disabled={this.props.disabled}
                    bordered={this.props.bordered}
                    disabledDate={current => {
                        // Can not select days before today and today

                        if(current && minDate?.isValid() && current < minDate.endOf('day')) {
                            return true;
                        }
                        if(current && maxDate?.isValid() && current > maxDate.startOf('day')) {
                            return true;
                        }
                        return false;
                    }}
                    suffixIcon={this.props.suffixIcon}
                    inputReadOnly={this.props.inputReadOnly}
                    tabIndex={this.props.isReadOnly ? -1 : undefined}
                    allowClear={this.props.allowClear}
                    placeholder={'Enter ' + (this.props.placeholder || 'Date')}
                    name={this.props.name}
                    format={this.props.format || "MMM Do, YYYY"}
                />

                <div className="invalid-feedback block transition-all ease-in"
                     style={errorMessage ? {opacity: 1,height: 30}:{opacity: 0,height: 0}}>
                    {errorMessage}
                </div>

            </div>
        )

    }
}

export default withFormsy(DateInput);